import m from "../../geodata/es2015/dominicanRepublicMuniLow";
window.am4geodata_dominicanRepublicMuniLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/dominicanRepublicMuniLow.js
// module id = null
// module chunks = 